import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-treatment',
  templateUrl: './modal-treatment.component.html',
  styleUrls: ['./modal-treatment.component.scss']
})
export class ModalTreatmentComponent implements OnInit {

    @Input() id = '';
    @Input() data: any;
    @Input() title = '';
    @Input() listMetodo: any = [];
    @Input() causaSelect: any;

    @Output() typeMethod = new EventEmitter();

    selectMetodo: any = '';

    constructor(
        public activeModal: NgbActiveModal,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        for (const key in this.causaSelect) {
            for (const key2 in this.listMetodo) {
                if (this.causaSelect[key].id === this.listMetodo[key2].id) {
                    this.listMetodo.splice(key2, 1);
                }
            }
        }
    }

    btnDismiss() {
        this.activeModal.dismiss();
    }

    btnAceptar() {
        this.listMetodo.map((element) => {
            if (element.id.toString() === this.selectMetodo) {
                this.typeMethod.emit(element);
            }
        });
        this.activeModal.close();
    }

}
